import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { encryptionService } from '../common-service/cedService';

@Injectable({
  providedIn: 'root'
})
export class CommonInterceptor implements HttpInterceptor {
  accesToken: string;
  constructor(public router: Router, public ced: encryptionService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): import('rxjs').Observable<HttpEvent<any>> {
    this.accesToken = this.ced.decryptingProcess('access-token');
    if (this.accesToken) {
      if (req.url.includes(('/getAllGroupsByPagination')) || (req.url.includes(('/listOfRoles')))
        || (req.url.includes(('/getAllSectionByEntityMaster'))) || (req.url.includes(('/getAllUserTypes')))
        || (req.url.includes(('/searchListOfPrivileges'))) || (req.url.includes(('/searchAllUsersData')))
        || (req.url.includes(('/getAllGroupsByAsc'))) || (req.url.includes(('/updateRoleAuthority')))
        || (req.url.includes(('/getAllDesignationByEntityMaster'))) || (req.url.includes(('/getAllUsers')))
        || (req.url.includes(('/AllPrivilages'))) || (req.url.includes(('/listOfAllPrivilages')))
        || (req.url.includes(('/updateRole'))) || (req.url.includes(('/AllPrivilagesByPage')))
        || (req.url.includes(('/AllPrivilagesByGroup'))) || (req.url.includes(('/listOfRolesByPage'))
          || (req.url.includes(('/searchListOfRoles'))) || (req.url.includes(('/createRole'))))
        || (req.url.includes(('/getAllEntityMaster'))) || (req.url.includes(('/searchManageUsersList')))
        || (req.url.includes(('/updateUser'))) || (req.url.includes(('/getLoggedInUserDetails')))
        || (req.url.includes(('/getRoleByRoleId'))) || (req.url.includes(('/getUserByUserId')))
        || (req.url.includes(('/getAllStates'))) || (req.url.includes(('/disableUser')))
        || (req.url.includes(('/get_all_tax'))) || (req.url.includes(('add_meeting_schedule')))
        || (req.url.includes(('/getReceiptDetailsByReceiptId'))) || (req.url.includes(('/get_permittedSeats_byCollege_Specialization')))
        || (req.url.includes(('/get_all_inspectors'))) || (req.url.includes(('/getAllReceiptsByUserIdAndPagination')))
        || (req.url.includes(('/assignReceiptToSectionIncharge'))) || (req.url.includes(('/get_all_states')))
        || (req.url.includes(('/updateDispatchDetails'))) || (req.url.includes(('/get_all_college_by_state')))
        || (req.url.includes(('/getAllInspectionTypes'))) || (req.url.includes(('/getInspectionCourseByTypeAndSubTypeAndPurpose')))
        || (req.url.includes(('/getInspectionPurposesByTypeAndSubType'))) || (req.url.includes(('/getInspectionSubTypesByType')))
        || (req.url.includes(('/get_college_staff'))) || (req.url.includes(('/getAllDentists')))
        || (req.url.includes(('/findAllCollegesByPagination'))) || (req.url.includes(('/delete_agenda')))
        || (req.url.includes(('/get_college_specialisation'))) || (req.url.includes(('inspector_reassign')))
        || (req.url.includes(('/get_ec_dashboard'))) || (req.url.includes(('get_upcoming_ecmeeting')))
        || (req.url.includes(('/get_agenda_for_complaint'))) || (req.url.includes(('get_view_case_item')))
        || (req.url.includes(('/get_all_meetings_history'))) || (req.url.includes(('view_agenda_by_id')))
        || (req.url.includes(('/get_meeting_venue_list'))) || (req.url.includes(('create_ec_agenda')))
        || (req.url.includes(('/get_agendalist_for_sh_review'))) || (req.url.includes(('/submit_section_head_refinement')))
        || (req.url.includes(('/searchMonitoringCellStudentList'))) || (req.url.includes(('/searchMonitoringCellCollegeList')))
        || (req.url.includes(('/add_meeting_venue_details'))) || (req.url.includes(('finalize_metting_date')))
        || (req.url.includes(('/get_dispatch_for_dashboard'))) || req.url.includes(('updateReceiptWithFileNum'))
        || (req.url.includes(('/get_dipatched_notesheets'))) || req.url.includes(('send_email_to_postal'))
        || (req.url.includes(('/remove_address'))) || req.url.includes(('/assignReceiptToSectionExecutive'))
        || (req.url.includes(('get_agenda_list_by_meeting_menu_id'))) || (req.url.includes(('/getAllReceiptLanguages')))
        || (req.url.includes(('/get_agenda_item_no'))) || (req.url.includes(('get_agenda_list_by_meeting_id')))
        || (req.url.includes(('GetUIDRDetailsList'))) || (req.url.includes(('get_current_academic_year')))
        || (req.url.includes(('/getAllCollegeList'))) || (req.url.includes(('/getAllUniversityList')))
        || (req.url.includes(('/GetCourseList'))) || (req.url.includes(('/GetSpecializationList'))) 
        || (req.url.includes(('/getRandomKeyGeneratorForViewDocument'))) || (req.url.includes(('/getProcessHistoryList')))
        || (req.url.includes(('/get_student_admission_notesheet_details')))) {
        req = req.clone({
          headers: req.headers.set('Access-Control-Allow-Origin', '*').set('Authorization', 'Bearer ' +
            this.accesToken)
            .set('Content-Type', 'application/json'),
          responseType: 'json',
        });
      } else if ((req.url.includes(('/GetCollegeListForSARSectionExcel')))) {
         req = req.clone({
    headers: req.headers
      .set('Access-Control-Allow-Origin', '*')
      .set('Authorization', 'Bearer ' + this.accesToken),

    responseType: 'blob'
  });

  return next.handle(req);
      }
      else if ((req.url.includes(('/updateDispatchUploadOnlyDocumentWithDraftAndEcCirculcations')))) {
        req = req.clone({
          headers: req.headers.set('Accept', 'application/json').set('Access-Control-Allow-Origin', '*')
            .set('Authorization', 'Bearer ' + this.accesToken).set('Content-Type', 'application/json;charset=UTF-8'),
          responseType: 'json',
        });
      } else if ((req.url.includes(('/upload_ticket_details')))  ||
        (req.url.includes(('/updateReceipt'))) || (req.url.includes(('/forwardto_sdc'))) 
        || (req.url.includes(('/re_appeal'))) || (req.url.includes(('/save_schedule_inspection'))) || (req.url.includes(('/reschedule_inspection'))) || (req.url.includes(('/cancel_inspection')))||
        (req.url.includes(('/forwardto_college'))) || (req.url.includes(('/mom_publish_final'))) ||
        (req.url.includes(('/updateDispatchUploadOnlyDocumentWithDraftAndEcCirculcations'))) || req.url.includes(('/send_mom_to_ec')) ||
        ((req.url.includes(('/college_feedback')))) || req.url.includes(('/get_dispatch_by_id')) ||
        (req.url.includes(('/promoteStudent'))) || req.url.includes(('/createReceipt')) || req.url.includes(('/UploadLegalAdvocateCommunication'))
        || req.url.includes(('/FileUploadForNewCollege')) || req.url.includes(('/FileUploadForUIDRCertificate'))
        || req.url.includes('/change_completed_final_status')|| req.url.includes('/manual_inspector_selection')) {
   
        req = req.clone({
          headers: req.headers.set('Accept', 'application/json').set('Access-Control-Allow-Origin', '*')
            .set('Authorization', 'Bearer ' + this.accesToken),
          responseType: 'json',
        });

      }
      else if (req.url.includes(('/word')) ) {
        req = req.clone({
          // headers: req.headers.set('Accept', 'text/html').set('Content-Type', 'text/html;charset=UTF-8'),
          // responseType: 'json'
          headers: req.headers.set('Content-Type', 'text/html; charset=utf-8').set('Access-Control-Allow-Origin', '*')
            .set('Authorization', 'Bearer ' + this.accesToken),
          responseType: 'blob',
        });
      }
      else if (req.url.includes(('/createDispatch')) || req.url.includes(('/createReceipt')) || req.url.includes(('/get_base_string_mom_file')) ||
        (req.url.includes(('/updateReceipt'))) || (req.url.includes(('/updateDispatch'))) || 
        (req.url.includes(('/save_dispatch'))) || (req.url.includes(('/uploadSignedPdf'))) || 
        (req.url.includes(('/documentUploads'))) || (req.url.includes(('/upload_clarification_documents'))) || 
        (req.url.includes(('/uploadESignedPdf'))) || (req.url.includes(('/update_document_type')))
        ||(req.url.includes(('/general_info_document_upload')))||(req.url.includes(('/save_college_general_info')))
        ||(req.url.includes(('/general_info_document_upload_list')))||(req.url.includes(('/attached_hosp_document_upload')))
        ||(req.url.includes(('/save_attached_hosp_info')))||(req.url.includes(('/CollegeBankDetailsFileUpload'))) || req.url.includes(('/CollegeInfrastructureDetailsFileUpload'))
        ||(req.url.includes(('/UploadBankDetailsStatement'))) || req.url.includes(('/uploadConstructionPlanning')) || req.url.includes(('/uploadLibraryDetails'))
        || req.url.includes(('/singleUpload')) || req.url.includes(('/singleUploadLibrary')) || req.url.includes(('/UploadDentalStaff')) || req.url.includes(('/UploadStaffPublication')) || req.url.includes(('/nonTeachingFileUpload'))
        || req.url.includes(('/DentalStaffFileUpload'))|| (req.url.includes(('/raise_complaint')))|| (req.url.includes(('/create_new_complaint'))) 
        || (req.url.includes(('/ecMeetingCreateAgenda-files-upload')))|| (req.url.includes(('/upload_file_infrastructure_proforma')))
        ||(req.url.includes(('/re_appeal_complaint')))||(req.url.includes(('/complaint_workflow_with_document')))
        ||(req.url.includes(('/fqsr_workflow_with_document')))||(req.url.includes(('/get_current_date')))||(req.url.includes(('/eligibility_workflow_with_document')))) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json').set('Access-Control-Allow-Origin', '*'),
          responseType: 'json',
        });
      } else if (req.url.includes(('/createStudentAdmission')) || req.url.includes(('/updateStudentAdmissionByAdmissionID'))
        || req.url.includes('/SubmittedToCA') || req.url.includes(('/file_Uploads_CreateNewCase')) || req.url.includes(('/update_remarks_college'))
        || req.url.includes(('/save_student_passing_criteria')) || req.url.includes(('/save_student_admission_period')) || req.url.includes(('/save_passing_criteria_details'))) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json'),
          responseType: 'json',
        });
      } else if (req.url.includes(('/updateAdmissionStatus'))) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json'),
          responseType: 'json',
        });
      }
      else if (req.url.includes(('/save_anti_ragging_program'))||req.url.includes(('/participantsFileUpload'))) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json'),
          responseType: 'json',
        });
      }
      
      else if ( req.url.includes(('/ViewDocument')) || req.url.includes(('/getDispatchFinalPdf')) || req.url.includes('/print_address') || req.url.includes('/previewDMSFiles') 
      || req.url.includes('/getAcceptanceLetterPdf') || req.url.includes('/dashBoardSearchSectionExport') 
      || req.url.includes('/finalPreview_MOMPDF') || req.url.includes('/bulkAgenda_ExportPdf') || req.url.includes('/finalpdfMom_ViewDocument') 
      || req.url.includes('/dashBoardDispatchExportPDF') || req.url.includes('/dakdispatch_dashboard_export_pdf') || req.url.includes('/queriesReportExportPDF') 
      || req.url.includes('/generateExcel') || req.url.includes('/generateStudentReportExcel') || req.url.includes('/queriesReportExportExcel') || req.url.includes('/audit_log_export_pdf')
      || req.url.includes('/collegeExcel') || req.url.includes('/GenerateDeficiencyReportPDF') || req.url.includes('/exportPDF') || req.url.includes('/exportMdmExcel') 
      || req.url.includes('/get_fqsr_list_export_pdf') || req.url.includes('/get_fqsr_list_export_excel') 
      || req.url.includes('/slaReport_ExportPdf') || req.url.includes('/get_complainant_view_export_pdf') 
      || req.url.includes('/getPtrApplicationView_exportPdf') || req.url.includes('/antiRaggingOrientationPDF')
      || req.url.includes('/get_anti_ragging_program_export_excel')|| req.url.includes('/get_eligibility_view_pdf')
      || req.url.includes('/exportExcel')|| req.url.includes('/exportUtilezationExcel') || req.url.includes('/vacant_seats_report_excel') || req.url.includes('/get_anti_ragging_list_export_excel')
      || req.url.includes('/sla_export_pdf')|| req.url.includes('/inspection_list_export_pdf')|| req.url.includes('/inspection_list_export_excel')
      || req.url.includes('/preview_office_order') || req.url.includes('/preview_acknowledgement_letter')
      || req.url.includes('/appointedInspectorListExportPDF') || req.url.includes('/appointedInspectorListExportExcel') || req.url.includes('/exportUserExcel')
      || req.url.includes('/import_holiday_master_excel')|| req.url.includes('/generateStudentExcel')|| req.url.includes('/avalInspectorDtlsExportExcel')|| req.url.includes('/ackdispatch_dashboard_export_pdf'))
       { 
        req = req.clone({
          headers: req.headers.set('Accept', 'application/json')
            .set('Authorization', 'Bearer ' + this.accesToken).set('Access-Control-Allow-Origin', '*'),
          responseType: 'blob',
        });
      }
      
      else if ((req.url.includes(('http://okmAdmin')))) {
        req = req.clone({
          headers: req.headers.set('Accept', '*'),
          // responseType: 'json',
          //  headers: req.headers.delete('Authorization', 'Bearer ' + this.accesToken),
          responseType: 'blob',

        });
        //  delete req.headers.set({})
        req.headers.delete('Authorization', 'Bearer ' + this.accesToken);
      } else if (req.url.includes('/ec-image-upload') || req.url.includes('/ec-admission-upload') || req.url.includes('/ectwelvethupload') || req.url.includes('/ec-sign-upload') || req.url.includes('/ec-files-upload') || req.url.includes('/ec-school-upload') || req.url.includes('/ec-passport-upload') || req.url.includes('/ec-relevant-upload') || req.url.includes('/ec-clearance-upload') || req.url.includes('/ec-bdsmark-upload') || req.url.includes('/ec-degree-upload') || req.url.includes('/ec-institution-upload') || req.url.includes('/ec-authority-upload') || req.url.includes('/ec-entrance-upload') || req.url.includes('/ec-prospectus-upload') || req.url.includes('/ec-reserved-upload') || req.url.includes('/ec-marks-upload') || req.url.includes('/ec-certificate-upload') || req.url.includes('/fqsrImmiuploadDocument')|| req.url.includes('/fileUpload')
        || req.url.includes('/prospectusFileUpload') || req.url.includes('/orientationCoursesFileUpload') || req.url.includes('/inquiryConductedFileUpload')
        || req.url.includes('/punishmentMetedFileUpload') || req.url.includes('/fIRLodgedDocumentsFileUpload')
      ) {
        req = req.clone({
          headers: req.headers.set('Access-Control-Allow-Origin', '*')
            .set('Authorization', 'Bearer ' + this.accesToken),
          responseType: 'json',
        });       
      } else if ((req.url.includes('/files')) || (req.url.includes('/DownloadUIDRCertificate'))
        || (req.url.includes('/getApplicantEligibilityCertificate')) || (req.url.includes('/downloadUploadFIle'))
        || (req.url.includes('/DownloadUploadedUIDRCertificate')) || (req.url.includes('/preview'))
        || (req.url.includes('DownloadUploadedUIDRHistoryCertificate')) || (req.url.includes('/getAntiRaggingPDF'))
        || (req.url.includes('DownloadUploadedAntiRaggingDocuments')) || (req.url.includes('dashBoardSearchExport'))
        || (req.url.includes('receiptDashBoardSearchExport') ) || (req.url.includes('/view_document'))
        || (req.url.includes('/searchStudentExportPDFCollege')) || (req.url.includes('DownloadAntiRaggingApplication'))
        || req.url.includes('/dci_official_letter_pdf')) {
        req = req.clone({
          headers: req.headers.set('Access-Control-Allow-Origin', '*')
            .set('Authorization', 'Bearer ' + this.accesToken),
          responseType: 'blob',
        });
      }

      //For Legal 
      else if ((req.url.includes('/getDispatchFinalPdf'))) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json'),
          responseType: 'json',
        });

      }
      else if ( (req.url.includes('/submitQueriesReports')) || (req.url.includes('/saveAdvocateFeeList')) ) { 
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json'),
          responseType: 'json',
        });

      } else if ((req.url.includes('/createUserLegal')) || (req.url.includes('/updateUserLegal')) || (req.url.includes('/submitDocumentRep')) 
      || (req.url.includes('/submitInvoice')) || (req.url.includes('/saveChange')) || (req.url.includes('/submitAdvocateInvoice')) || (req.url.includes('/submitAdvocateDashboardCommunication'))  
      || (req.url.includes('/createCategoryLegal')) || (req.url.includes('/saveDocumentTemplate')) || (req.url.includes('/submitCommunication'))) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + this.accesToken).set('Accept', 'application/json'),
          responseType: 'json',
        });
      } else if((req.url.includes('/get_captcha_value')) || (req.url.includes('/getRandomKeyGenerator')) 
      || (req.url.includes('/getOauthAccessToken')) || (req.url.includes('/login_data_success_audit_log')) || (req.url.includes('/log_out_data_audit_log')) 
      || (req.url.includes('/session_timout_audit_log')) || (req.url.includes('/login_data_failed_audit_log'))
      || (req.url.includes('/change_role_audit_log'))) {
        req = req.clone({
        headers: req.headers.set('Accept', 'application/json').set('Access-Control-Allow-Origin', '*'),
        responseType: 'json',
      });
    }

      else {
        req = req.clone({
          headers: req.headers.set('content-type', 'application/json').set('Authorization', 'Bearer ' +
            this.accesToken),
          responseType: 'json',
        });
      }
    } else if ((req.url.includes(('/getOauthAccessToken'))) || (req.url.includes(('/login_data_failed_audit_log')))
      || (req.url.includes(('/inspector_reponse'))) || (req.url.includes(('/forgot_password')))
      || (req.url.includes(('/saveAllCollegeRegistration'))) || (req.url.includes(('/getRandomKeyGeneratorForWebsite')))
      || (req.url.includes('/generate_captcha_image')) || (req.url.includes('/get_captcha_value')) 
      || (req.url.includes('/getRandomKeyGenerator')) || (req.url.includes('/getLoggedInUserDetails'))
      || (req.url.includes('/login_data_success_audit_log')) || (req.url.includes('/getEcApplicantImage')) 
      || (req.url.includes('/getEcApplicantSign')) || (req.url.includes('/getEcApplicantDocument')) 
      || (req.url.includes('/get_fqsr_applicant_image')) || (req.url.includes('/get_fqsr_applicant_sign'))
      || (req.url.includes('/get_photograph_image_list')) || (req.url.includes('/getAntiRaggingProgramList'))
      || (req.url.includes('/deleteOauthToken')) || (req.url.includes('/send_sms_test')) 
      || (req.url.includes('/send_mobile_otp_test')) || (req.url.includes(('/forgot_user')))) {
      req = req.clone({
        headers: req.headers.set('Accept', 'application/json').set('Access-Control-Allow-Origin', '*'),
        responseType: 'json',
      });
    } 

    return next.handle(req);
  }
}



